import styled from '@emotion/styled';
import { color, font } from 'src/shared/styles/variables';

export const FloatingLabel = styled('label')(
    {
        display: 'block',
        marginTop: 20,
        marginBottom: 8,
        color: `${color.steelGray} !important`,
    },
    font.heavy(font.size.base),
);
